/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pricedata } from "../Data/ComponentsData/componentsdata";
import { Col, Container, Row } from "reactstrap";

const Price = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const swiperOptions = {
    spaceBetween: 15,
    slidesPerView: 1,
    breakpoints: {
      600: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1000: {
        slidesPerView: 4,
      },
    },
    loop: true,
    navigation: {
      prevEl: prevRef.current,
      nextEl: nextRef.current,
    },
  };

  useEffect(() => {
    if (prevRef.current && nextRef.current) {
      swiperOptions.navigation.prevEl = prevRef.current;
      swiperOptions.navigation.nextEl = nextRef.current;
    }
  }, []);

  return (
    <section className='theme-bg pricing-slider-box' id='package'>
      <Container>
        <Row>
          <Col md={12} className='text-center'>
            <div className='section-title'>
              <h2 className='text-white'>Our Pricing Plans</h2>
              <img src='assets/images/white-line.png' alt='title-line' className='img-fluid' />
            </div>
          </Col>
          <Col md={12} className='text-center'>
            <div className='swiper-button-container'>
              <button ref={prevRef} className='swiper-button-prev'></button>
              <button ref={nextRef} className='swiper-button-next'></button>
            </div>
            <Swiper
              {...swiperOptions}
              modules={[Navigation]}
              onSwiper={(swiper) => {
                // Update navigation elements once Swiper instance is ready
                swiper.navigation.init();
                swiper.navigation.update();
              }}
            >
              {Pricedata.map((val, i) => (
                <SwiperSlide key={i}>
                  <div className='package-box'>
                    <h3>{val.title}</h3>
                    <div className='price-box'>
                      <span>$</span>
                      <h2>{val.price}</h2>
                      <h5 className='plan-clr'>
                        <span className='d-block'>Year</span>
                      </h5>
                    </div>
                    <div className='price-plan text-center'>
                      <ul>
                        <li>{val.label}</li>
                        {val.features.map((feature, index) => (
                          <li key={index}>{feature}</li>
                        ))}
                      </ul>
                      <div className='price-plan-btn'>Select Plan</div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Price;
